import { router, usePage } from '@inertiajs/react'
import { useState } from 'react'
import type { SharedProps } from '../types'
import { t } from '../lib/i18n'

// 「去确认一下邮箱」。挂在 AppLayout 上，所以登录后的每一页都能看到。
//
// 刻意**没有**「以后再说」的关闭按钮：关掉之后这条提示就再也不会出现，而它要
// 解决的问题（忘了密码却收不到重置信）恰恰是在几个月之后才暴露的。唯一让它
// 消失的办法就是去点那封信 —— 那正是我们想要的那个动作。
export default function ConfirmEmailBanner() {
  const { props } = usePage<SharedProps>()
  const user = props.auth?.user
  const [sending, setSending] = useState(false)

  // emailConfirmed 为 undefined 时不渲染：那说明这一页的 props 根本没带 auth
  // （比如还没登录），而不是「没确认」。
  if (!user || user.emailConfirmed !== false) return null

  const resend = () => {
    setSending(true)
    router.post(
      '/email_confirmation',
      {},
      // preserveScroll：横幅在页顶，发完信页面会被 flash 顶下去一点，
      // 没必要把人也拉回顶部。
      { preserveScroll: true, onFinish: () => setSending(false) },
    )
  }

  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-brand-line bg-brand-glass2 p-3 text-sm text-brand-ink"
    >
      <span>
        {t(
          <>
            还没确认 <strong className="font-medium">{user.email}</strong>。
            确认过之后，万一忘了密码我们才能把重置链接发给你。
          </>,
          <>
            <strong className="font-medium">{user.email}</strong> isn’t confirmed yet. Once it is, we can send you a reset
            link if you forget your password.
          </>,
        )}
      </span>
      <button
        type="button"
        onClick={resend}
        disabled={sending}
        className="ml-auto rounded-full border border-brand-line px-3 py-1 text-xs font-medium text-brand-ink2 transition hover:border-brand-primary hover:text-brand-primaryDeep disabled:opacity-60"
      >
        {sending ? t('发送中…', 'Sending…') : t('重新发一封', 'Resend email')}
      </button>
    </div>
  )
}
